import { cn } from 'support/helpers/cn/cn';
import { Button } from 'components/Form/Button';
import { ButtonType } from 'components/Form/Button/Button';

type AgentMessageCardAction = Pick<ButtonType, 'onClick' | 'analyticsId' | 'LeftIcon' | 'variant'> &
  Required<Pick<ButtonType, 'onClick'>> & {
    label: string;
  };

type AgentMessageCardProps = {
  title?: string;
  subtitle?: string;
  description?: string;
  actions?: Array<AgentMessageCardAction>;
};

export const AgentMessageCard = ({ title, subtitle, description, actions }: AgentMessageCardProps) => {
  const hasActions = actions && actions.length > 0;

  return (
    <div className={cn('flex flex-col gap-2 rounded-xl border! border-gray-200 p-4 text-gray-900')}>
      {(title || subtitle) && (
        <div>
          {title && <p className={cn('text-sm leading-5 font-medium text-gray-900')}>{title}</p>}
          {subtitle && <p className="text-xs leading-4 font-normal text-gray-500">{subtitle}</p>}
        </div>
      )}
      {description && <p className={cn('text-sm', !hasActions ? 'text-gray-500' : 'text-gray-700')}>{description}</p>}
      {hasActions && (
        <div className="mt-1 flex gap-2">
          {actions.map((action) => (
            <Button
              key={action.analyticsId}
              analyticsId={action.analyticsId}
              LeftIcon={action.LeftIcon}
              onClick={action.onClick}
              variant={action.variant}
              size="small"
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
